export const defaultLocale = 'de'

export const supportedLanguages = [
  { code: 'de', label: 'Deutsch', shortLabel: 'DE' },
  { code: 'en', label: 'English', shortLabel: 'EN' }
]

const discordInviteUrl = 'https://discord.gg/DxCnKYTk5g'
const botInviteUrl = 'https://discord.com/oauth2/authorize?client_id=1207976331577663519&permissions=8&scope=bot'
const dashboardUrl = 'https://dashboard.guildguardian.de/'
const premiumPurchaseUrl = 'https://dashboard.guildguardian.de/guild/premium'
const youtubeUrl = 'https://www.youtube.com/@GuildGuardian'
const tiktokUrl = 'https://www.tiktok.com/@guildguardian'
const xUrl = 'https://x.com'
const instagramUrl = 'https://www.instagram.com'

const imprintBlocks = [
  {
    title: 'Angaben gemäß § 5 DDG',
    lines: ['Alexander Wodarz', 'Schützenstraße 9', '12165 Berlin']
  },
  {
    title: 'Kontakt',
    lines: ['Telefon: 0176-84860292', 'E-Mail: kontakt@guildguardian.de']
  },
  {
    title: 'Haftungsausschluss',
    paragraphs: []
  },
  {
    title: 'Haftung für Inhalte',
    paragraphs: [
      'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
      'Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'
    ]
  },
  {
    title: 'Haftung für Links',
    paragraphs: [
      'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
      'Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.'
    ]
  },
  {
    title: 'Datenschutz',
    paragraphs: [
      'Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten, beispielsweise Name, Anschrift oder E-Mail-Adressen, erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.',
      'Wir weisen darauf hin, dass die Datenübertragung im Internet, zum Beispiel bei der Kommunikation per E-Mail, Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.',
      'Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.'
    ]
  },
  {
    title: 'Google AdSense',
    paragraphs: [
      'Diese Website benutzt Google AdSense, einen Webanzeigendienst der Google Inc., USA, Google. Google AdSense verwendet sogenannte Cookies, also Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Google AdSense verwendet auch sogenannte Web Beacons, kleine unsichtbare Grafiken, zur Sammlung von Informationen.',
      'Durch die Verwendung des Web Beacons können einfache Aktionen wie der Besucherverkehr auf der Webseite aufgezeichnet und gesammelt werden. Die durch den Cookie und/oder Web Beacon erzeugten Informationen über Ihre Benutzung dieser Website, einschließlich Ihrer IP-Adresse, werden an einen Server von Google in den USA übertragen und dort gespeichert.',
      'Google wird diese Informationen benutzen, um Ihre Nutzung der Website im Hinblick auf die Anzeigen auszuwerten, um Reports über die Websiteaktivitäten und Anzeigen für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben ist oder soweit Dritte diese Daten im Auftrag von Google verarbeiten.',
      'Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten von Google in Verbindung bringen. Das Speichern von Cookies auf Ihrer Festplatte und die Anzeige von Web Beacons können Sie verhindern, indem Sie in Ihren Browser-Einstellungen keine Cookies akzeptieren wählen. Wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können.',
      'Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.'
    ]
  },
  {
    title: '',
    paragraphs: ['Impressum vom Impressum Generator der Kanzlei Hasselbach, Bonn']
  }
]

const privacyBlocks = [
  imprintBlocks[0],
  imprintBlocks[1],
  imprintBlocks[5],
  imprintBlocks[6]
]

const germanHomepageContent = {
  navigation: [
    { label: 'Startseite', href: '/', icon: 'home' },
    { label: 'Funktionen', href: '/#features', icon: 'star' },
    { label: 'Team', href: '/Team', icon: 'team' },
    { label: 'Status', href: 'https://stats.uptimerobot.com/e9IjVAPipk', icon: 'status' },
    { label: 'Support', href: '/#faq', icon: 'info' },
    { label: 'Dashboard', href: dashboardUrl, icon: 'dashboard' },
    { label: 'Ressourcen', href: '#resources', icon: 'resources' }
  ],
  language: {
    label: 'Deutsch',
    shortLabel: 'DE'
  },
  resources: {
    columns: [
      {
        title: 'Unterstützung',
        items: [
          {
            title: 'Tutorials',
            copy: 'Lies unsere Dokumentation, um zu erfahren, wie du GuildGuardian auf Discord nutzen kannst.',
            icon: 'info',
            href: '/Dokumentation'
          },
          {
            title: 'Projekt unterstützen',
            copy: 'Hilf mit Feedback, Beta Tests, Empfehlungen oder später Premium dabei, GuildGuardian besser zu machen.',
            icon: 'heart',
            href: '/Unterstuetzen'
          },
          {
            title: 'Discord Server',
            copy: 'Tritt unserem Discord Server bei, um Hilfe zu bekommen und mit der Community zu sprechen.',
            icon: 'discord',
            href: discordInviteUrl
          }
        ]
      },
      {
        title: 'Unternehmen',
        items: [
          {
            title: 'Karriere',
            badge: 'Wir stellen ein!',
            copy: 'Werde Teil von GuildGuardian und erschaffe Systeme, die Online-Communitys besser machen.',
            icon: 'team',
            href: '/Karriere'
          },
          {
            title: 'BETA Tester Programm',
            copy: 'Teste die neuesten Funktionen von GuildGuardian, entdecke Fehler und melde sie uns.',
            icon: 'bug',
            href: '/Beta'
          },
          {
            title: 'Kontaktiere uns',
            copy: 'Wir sind offen und freundlich. Melde dich, wenn du Fragen oder Ideen hast.',
            icon: 'contact',
            href: 'mailto:kontakt@guildguardian.de'
          }
        ]
      }
    ]
  },
  headerActions: [
    { label: 'Premium', href: '/premium', variant: 'premium', icon: 'crown' },
    { label: 'Dashboard', href: dashboardUrl, variant: 'dashboard', icon: 'dashboard' }
  ],
  hero: {
    kicker: 'GuildGuardian für Discord',
    titleLines: ['Sicherheit für deinen Server.', 'Moderation ohne Chaos.'],
    copy: 'Automatisiere Schutz, Tickets, Logs und Invite Tracking in einem Dashboard, das dein Team wirklich schnell bedienen kann.',
    primaryAction: {
      label: 'Bot einladen',
      href: botInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'Features ansehen',
      href: '#features',
      icon: 'star'
    }
  },
  premium: {
    kicker: 'Premium',
    title: 'Mehr Kontrolle für deinen Discord Server.',
    copy: 'Wähle dein monatliches GuildGuardian Abo und schalte mehr Bewerbungen, Embeds, Custombot Optionen und Komfortfunktionen frei.',
    billingLabel: 'Nur monatliche Abos',
    recommendedLabel: 'Beliebt',
    tableTitle: 'Vergleiche alle Modelle',
    tableCopy: 'Alle Limits und Funktionen auf einen Blick. Du kannst mit Kostenlos starten und später upgraden.',
    includedLabel: 'Enthalten',
    notIncludedLabel: 'Nicht enthalten',
    primaryAction: {
      label: 'Abo im Dashboard wählen',
      href: premiumPurchaseUrl,
      icon: 'dashboard'
    },
    secondaryAction: {
      label: 'Modelle vergleichen',
      href: '#premium-plans',
      icon: 'star'
    },
    plans: [
      {
        name: 'Kostenlos',
        price: '0 €',
        period: '/ Monat',
        description: 'Für kleine Server, die GuildGuardian testen und die wichtigsten Grundfunktionen nutzen möchten.',
        action: 'Kostenlos starten',
        href: premiumPurchaseUrl,
        icon: 'shield',
        highlights: ['3 Bewerbungen', '3 Embeds', '2 Apply Limits']
      },
      {
        name: 'Freemium',
        badge: 'Beliebt',
        notice: 'Mit Werbung',
        price: '0 €',
        period: '/ Monat',
        description: 'Kostenloses Upgrade mit mehr Limits und Komfortfunktionen. Dafür wird deutlich mehr Werbung eingeblendet.',
        action: 'Freemium wählen',
        href: premiumPurchaseUrl,
        icon: 'spark',
        featured: true,
        highlights: ['Custombot enthalten', '5 Bewerbungen', '10 Embeds', 'Stats und Import']
      },
      {
        name: 'Premium',
        price: '4,99 €',
        period: '/ Monat',
        description: 'Für große Server und Teams, die unbegrenzte Limits und maximale Kontrolle brauchen.',
        action: 'Premium wählen',
        href: premiumPurchaseUrl,
        icon: 'crown',
        highlights: ['Unendliche Bewerbungen', 'Unendliche Embeds', 'Custombot']
      }
    ],
    comparisonColumns: ['Kostenlos', 'Freemium', 'Premium'],
    comparisonGroups: [
      {
        title: 'Allgemein',
        rows: [
          { label: 'Werbung eingeblendet', values: ['Nein', 'Ja', 'Nein'] },
          { label: 'Custombot', values: [false, true, true] },

          { label: 'Bewerbungen', values: ['3', '5', 'Unendlich'] },
          { label: 'Stats', values: [false, true, true] }
        ]
      },
      {
        title: 'Embeds',
        rows: [
          { label: 'Anzahl', values: ['3', '10', 'Unendlich'] },
          { label: 'Importieren', values: [false, true, true] }
        ]
      },
      {
        title: 'Apply',
        rows: [
          { label: 'Limit', values: ['2', '5', 'Unendlich'] },
          { label: 'Listen', values: [false, true, true] }
        ]
      },
      {
        title: 'Join',
        rows: [
          { label: 'Bilder', values: [false, true, true] },
          { label: 'Dynamische Bilder', values: [false, true, true] },
          { label: 'Private Nachricht', values: [false, true, true] }
        ]
      }
    ],
    note: 'Preise und Funktionen können sich bis zum finalen Release noch ändern.'
  },
  maintenancePages: {
    features: {
      kicker: 'Wartung',
      title: 'Die Feature Seite wird gerade überarbeitet.',
      copy: 'Wir sortieren die Inhalte neu, damit du später alle GuildGuardian Funktionen klarer und übersichtlicher findest.',
      primaryAction: {
        label: 'Zur Startseite',
        href: '/',
        icon: 'home'
      },
      secondaryAction: {
        label: 'Discord beitreten',
        href: discordInviteUrl,
        icon: 'discord'
      }
    },
    documentation: {
      kicker: 'Dokumentation',
      title: 'Die Dokumentation befindet sich im Aufbau.',
      copy: 'Tutorials, Setup-Anleitungen und Erklärungen werden aktuell vorbereitet. Bis dahin bekommst du Hilfe direkt über unseren Discord Server.',
      primaryAction: {
        label: 'Discord beitreten',
        href: discordInviteUrl,
        icon: 'discord'
      },
      secondaryAction: {
        label: 'Zur Startseite',
        href: '/',
        icon: 'home'
      }
    }
  },
  supportProjectPage: {
    kicker: 'Projekt unterstützen',
    title: 'Hilf mit, GuildGuardian besser zu machen.',
    copy: 'GuildGuardian wächst durch aktive Server, ehrliches Feedback und Menschen, die neue Funktionen testen. Du kannst das Projekt auch ohne Geld sinnvoll unterstützen.',
    status: 'Community Support',
    primaryAction: {
      label: 'Discord beitreten',
      href: discordInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'Bot einladen',
      href: botInviteUrl,
      icon: 'dashboard'
    },
    noteKicker: 'Wichtig',
    noteTitle: 'Aktuell ist Unterstützung vor allem kostenlos.',
    noteCopy: 'Eine direkte Spendenfunktion ist noch nicht aktiv. Wenn Premium oder andere Unterstützungswege verfügbar sind, werden sie offiziell angekündigt. Bis dahin helfen Aktivität, Feedback und Weiterempfehlungen am meisten.',
    options: [
      {
        icon: 'dashboard',
        title: 'GuildGuardian aktiv nutzen',
        copy: 'Lade den Bot auf deinen Server ein und nutze die Schutz-, Ticket- und Logging-Funktionen im echten Alltag.',
        action: 'Dashboard öffnen',
        href: dashboardUrl
      },
      {
        icon: 'message',
        title: 'Feedback geben',
        copy: 'Sag uns, welche Funktionen fehlen, welche Abläufe unklar sind und wo das Dashboard einfacher werden sollte.',
        action: 'Discord öffnen',
        href: discordInviteUrl
      },
      {
        icon: 'bug',
        title: 'Beta Tester werden',
        copy: 'Teste neue Funktionen früher, melde Fehler sauber und hilf dabei, Releases stabiler zu machen.',
        action: 'Beta Programm ansehen',
        href: '/Beta'
      },
      {
        icon: 'team',
        title: 'Im Team mitarbeiten',
        copy: 'Wenn du dauerhaft helfen möchtest, kannst du dich für offene Rollen im Team bewerben.',
        action: 'Karriere ansehen',
        href: '/Karriere'
      },
      {
        icon: 'spark',
        title: 'Projekt weiterempfehlen',
        copy: 'Empfiehl GuildGuardian an andere Discord-Server, die Moderation, Tickets oder Schutzfunktionen brauchen.',
        action: 'Features ansehen',
        href: '/Features'
      },
      {
        icon: 'crown',
        title: 'Premium im Blick behalten',
        copy: 'Premium startet später mit GuildGuardian V3. Damit kannst du das Projekt künftig direkter unterstützen.',
        action: 'Premium ansehen',
        href: '/Premium'
      }
    ],
    impactKicker: 'Warum das hilft',
    impactTitle: 'Deine Unterstützung landet direkt im Produkt.',
    impact: [
      'Feedback zeigt uns, welche Funktionen wirklich gebraucht werden.',
      'Aktive Server helfen dabei, Probleme unter echten Bedingungen zu erkennen.',
      'Beta Tests machen neue Releases stabiler und verständlicher.',
      'Weiterempfehlungen bringen mehr Communitys zu GuildGuardian.',
      'Bewerbungen helfen uns, Support, Entwicklung und Community besser aufzustellen.'
    ]
  },
  betaPage: {
    kicker: 'Beta Tester Programm',
    title: 'Teste neue GuildGuardian Funktionen, bevor sie live gehen.',
    copy: 'Im Beta Programm bekommst du frühen Zugriff auf neue Systeme, Dashboard-Änderungen und Bot-Funktionen. Du hilfst uns dabei, Fehler zu finden, Abläufe zu verbessern und GuildGuardian stabiler zu machen.',
    signal: 'Early Access',
    primaryAction: {
      label: 'Auf Discord bewerben',
      href: discordInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'Features ansehen',
      href: '/Features',
      icon: 'star'
    },
    voluntaryKicker: 'Wichtiger Hinweis',
    voluntaryTitle: 'Freiwillig und ohne Bezahlung.',
    voluntaryCopy: 'Das Beta Tester Programm ist freiwillig. Für das Finden, Melden oder Dokumentieren von Fehlern gibt es kein Geld, keine Auszahlung und keine garantierte Belohnung. Du hilfst mit, weil du GuildGuardian verbessern möchtest und frühe Funktionen testen willst.',
    highlights: [
      {
        icon: 'spark',
        title: 'Früher Zugriff',
        copy: 'Du testest neue Features, bevor sie für alle Server freigeschaltet werden.'
      },
      {
        icon: 'bug',
        title: 'Fehler melden',
        copy: 'Du dokumentierst Bugs, unklare Abläufe und Stellen, an denen etwas nicht logisch wirkt.'
      },
      {
        icon: 'message',
        title: 'Feedback geben',
        copy: 'Du sagst uns, welche Funktionen nützlich sind und was für echte Discord-Teams fehlt.'
      },
      {
        icon: 'lock',
        title: 'Vertraulich testen',
        copy: 'Beta-Inhalte bleiben intern, bis sie offiziell angekündigt oder veröffentlicht werden.'
      },
      {
        icon: 'team',
        title: 'Direkter Austausch',
        copy: 'Du sprichst direkt mit Team und Entwicklern, damit Feedback schnell umgesetzt werden kann.'
      },
      {
        icon: 'status',
        title: 'Stabilität prüfen',
        copy: 'Du hilfst zu prüfen, ob neue Systeme im echten Server-Alltag zuverlässig funktionieren.'
      }
    ],
    processKicker: 'Ablauf',
    processTitle: 'So läuft das Beta Programm ab.',
    steps: [
      {
        number: '01',
        title: 'Discord beitreten',
        copy: 'Du kommst auf unseren Discord und meldest dein Interesse am Beta Tester Programm.'
      },
      {
        number: '02',
        title: 'Kurz vorstellen',
        copy: 'Wir schauen, ob du aktiv bist, sauber Feedback geben kannst und zuverlässig testest.'
      },
      {
        number: '03',
        title: 'Beta-Zugang erhalten',
        copy: 'Wenn es passt, bekommst du Zugriff auf Beta-Kanäle, Testhinweise und neue Funktionen.'
      },
      {
        number: '04',
        title: 'Testen und melden',
        copy: 'Du testest gezielt neue Funktionen und meldest Fehler mit klaren Infos und Screenshots.'
      }
    ],
    expectationsTitle: 'Was wir erwarten',
    expectations: [
      'Du bist regelmäßig auf Discord erreichbar.',
      'Du gibst klares, ehrliches und konstruktives Feedback.',
      'Du meldest Fehler mit nachvollziehbaren Schritten.',
      'Du behandelst Beta-Inhalte vertraulich.',
      'Du hast Lust, GuildGuardian wirklich besser zu machen.'
    ],
    notForTitle: 'Nicht geeignet, wenn',
    notFor: [
      'du nur frühere Features nutzen willst, aber kein Feedback gibst.',
      'du interne Inhalte öffentlich teilst.',
      'du selten erreichbar bist.',
      'du Bugs nur grob meldest, ohne Details zu nennen.'
    ]
  },
  teamPage: {
    kicker: 'Team',
    title: 'Die Menschen hinter GuildGuardian.',
    copy: 'Unser Team baut Schutz, Dashboard, Support und Community direkt aus der Praxis für Discord Server.',
    discordLabel: 'Discord',
    roleLabel: 'Position',
    recruiting: {
      kicker: 'Karriere',
      title: 'Du möchtest an diesem Projekt mitwirken?',
      copy: 'Dann ergänze das Team im Bereich Support und Entwicklung und starte deine Karriere heute bei GuildGuardian.',
      action: 'Jetzt Bewerben',
      href: '/Karriere'
    },
    members: [
      {
        name: 'Meister Keks',
        discord: '@meisterkeks',
        accent: 'gold',
        image: 'meisterKeks',
        positions: ['Inhaber', 'Head Developer', 'Backend Developer', 'Bot Developer']
      },
      {
        name: 'Thorin',
        discord: '@thorin030',
        accent: 'cyan',
        image: 'damaging',
        positions: ['Inhaber', 'Frontend Developer', 'Web Developer', 'Community Manager', 'Marketing', 'Team Manager']
      },
      {
        name: 'Damaging',
        discord: '@damaglng',
        accent: 'violet',
        image: 'thorin',
        positions: ['Supporter']
      }
    ]
  },
  careerPage: {
    kicker: 'Karriere bei GuildGuardian',
    title: 'Baue mit uns die nächste Version für Discord Communitys.',
    copy: 'Wir suchen Menschen, die Verantwortung übernehmen, sauber kommunizieren und Lust haben, GuildGuardian aktiv weiterzuentwickeln.',
    primaryAction: {
      label: 'Offene Positionen ansehen',
      href: '#offene-positionen',
      icon: 'team'
    },
    secondaryAction: {
      label: 'Team ansehen',
      href: '/Team',
      icon: 'team'
    },
    ndaNotice: {
      title: 'Wichtige Anmerkung',
      copy: 'Für die Mitarbeit bei GuildGuardian muss eine NDA (Geheimhaltungsvereinbarung) unterschrieben werden, damit interne Daten, Systeme und vertrauliche Informationen geschützt bleiben.'
    },
    openingsTitle: 'Offene Positionen',
    openings: [
      {
        icon: 'code',
        title: 'Bot Developer',
        slug: 'botdeveloper',
        copy: 'Entwickle neue Bot-Features, Commands und Automationen direkt für Discord Server.',
        tags: ['Discord API', 'Commands', 'Automationen'],
        detailTitle: 'Entwickle den Kern von GuildGuardian.',
        detailCopy: 'Als Bot Developer arbeitest du an Commands, Moderationssystemen, Events und Discord-Integrationen. Du denkst in stabilen Abläufen und sorgst dafür, dass der Bot schnell, sauber und verlässlich reagiert.',
        requirements: ['JavaScript Kenntnisse', 'Interesse an Discord Bots und APIs', 'Saubere Kommunikation im Team'],
        questions: [
          'Welche Programmiersprachen beherrschst du?',
          'Mit welchen Discord Libraries arbeitest du?',
          'Hast du bereits eigene Discord Bots entwickelt?',
          'Wie würdest du deine Kenntnisse von 1-10 einschätzen?',
          'Kennst du dich mit Datenbanken aus? Wenn ja, welche?',
          'Hast du Erfahrung mit APIs oder Webhooks?',
          'Wie gehst du beim Debugging von Fehlern vor?',
          'Hast du Erfahrung mit Git/GitHub?',
          'Hast du schon einmal mit Slash Commands gearbeitet?',
          'Wie wichtig sind für dich Struktur und sauberer Code?',
          'Kannst du unter Zeitdruck arbeiten?',
          'Zeige uns ein Projekt oder Repository von dir.'
        ]
      },
      {
        icon: 'headset',
        title: 'Supporter',
        slug: 'supporter',
        copy: 'Hilf Nutzern bei Fragen, Tickets und Problemen im Alltag.',
        tags: ['Discord Support', 'Tickets', 'Community'],
        detailTitle: 'Sei die erste Hilfe für unsere Community.',
        detailCopy: 'Als Supporter beantwortest du Fragen, hilfst bei Einrichtung und Problemen und leitest wichtiges Feedback an das Team weiter.',
        requirements: ['Freundlicher Umgang mit Nutzern', 'Geduld bei Supportfällen', 'Grundwissen über Discord Server'],
        questions: [
          'Hast du bereits Erfahrung im Support?',
          'Wie würdest du mit einem toxischen Nutzer umgehen?',
          'Wie reagierst du auf Stress oder viele Tickets gleichzeitig?',
          'Kannst du ruhig und professionell bleiben?',
          'Wie aktiv bist du normalerweise auf Discord?',
          'Warum möchtest du Supporter werden?',
          'Was macht guten Support für dich aus?',
          'Wie würdest du einem neuen Nutzer helfen?',
          'Hast du Erfahrung mit Ticket-Systemen?',
          'Wie würdest du Streit zwischen zwei Nutzern lösen?'
        ]
      },
      {
        icon: 'code',
        title: 'Api Developer',
        slug: 'apideveloper',
        copy: 'Entwickle JavaScript APIs, Datenlogik und technische Grundlagen für Dashboard und Systeme.',
        tags: ['JavaScript', 'API', 'Server'],
        detailTitle: 'Baue die API-Grundlage hinter Dashboard und Bot.',
        detailCopy: 'Als Api Developer entwickelst du JavaScript Schnittstellen, Datenstrukturen und Services, die GuildGuardian im Hintergrund antreiben.',
        requirements: ['JavaScript Kenntnisse', 'Verständnis für APIs und Daten', 'Strukturiertes Arbeiten'],
        questions: [
          'Wie gut beherrschst du JavaScript?',
          'Mit welchen Frameworks hast du Erfahrung?',
          'Hast du Erfahrung mit Datenbanken?',
          'Hast du schon APIs entwickelt?',
          'Wie wichtig ist Sicherheit für dich?',
          'Kennst du dich mit Hosting/Linux/Docker aus?',
          'Hast du Erfahrung mit Authentifizierungssystemen?',
          'Wie strukturierst du größere Projekte?',
          'Hast du schon mit Echtzeit-Systemen gearbeitet?',
          'Zeige uns Projekte oder GitHub-Repositories.'
        ]
      },
      {
        icon: 'team',
        title: 'Community Manager',
        slug: 'communitymanager',
        copy: 'Halte die Community aktiv, informiere Nutzer und sammle Feedback.',
        tags: ['Community', 'Feedback', 'Events'],
        detailTitle: 'Verbinde Team und Community.',
        detailCopy: 'Als Community Manager sorgst du für Aktivität, klare Kommunikation und eine gute Stimmung rund um GuildGuardian.',
        requirements: ['Kommunikationsstärke', 'Ideen für Community-Aktionen', 'Verlässlichkeit'],
        questions: [
          'Hast du Erfahrung im Community Management?',
          'Wie würdest du eine Community aktiv halten?',
          'Welche Ideen hast du für Events oder Aktionen?',
          'Wie gehst du mit Konflikten um?',
          'Wie wichtig ist Kommunikation für dich?',
          'Hast du Erfahrung mit Partnerschaften?',
          'Wie würdest du neue Mitglieder willkommen heißen?',
          'Was macht eine gute Community aus?',
          'Wie würdest du auf negatives Feedback reagieren?',
          'Wie aktiv bist du auf Discord?'
        ]
      },
      {
        icon: 'team',
        title: 'Team Manager',
        slug: 'teammanager',
        copy: 'Koordiniere Aufgaben, Teamabläufe und interne Kommunikation.',
        tags: ['Organisation', 'Planung', 'Team'],
        detailTitle: 'Halte das Team organisiert.',
        detailCopy: 'Als Team Manager hilfst du dabei, Aufgaben sauber zu verteilen, Fortschritt im Blick zu behalten und das Team gut zu koordinieren.',
        requirements: ['Organisationstalent', 'Klare Kommunikation', 'Verantwortungsbewusstsein'],
        questions: [
          'Hast du bereits Teams geleitet?',
          'Wie würdest du Aufgaben im Team organisieren?',
          'Wie gehst du mit inaktiven Teammitgliedern um?',
          'Kannst du Konflikte neutral lösen?',
          'Wie wichtig sind Struktur und Planung für dich?',
          'Wie würdest du Motivation im Team fördern?',
          'Hast du Erfahrung mit Projektmanagement?',
          'Wie würdest du Deadlines organisieren?',
          'Wie gehst du mit Stresssituationen um?',
          'Was macht einen guten Teamleiter aus?'
        ]
      },
      {
        icon: 'megaphone',
        title: 'Marketing',
        slug: 'marketing',
        copy: 'Plane Inhalte, Ankündigungen und Wachstum für GuildGuardian.',
        tags: ['Content', 'Social', 'Branding'],
        detailTitle: 'Bring GuildGuardian nach draußen.',
        detailCopy: 'Im Marketing erstellst du Ideen für Posts, Ankündigungen und Kampagnen, damit mehr Server GuildGuardian entdecken.',
        requirements: ['Kreative Ideen', 'Gefühl für Texte und Zielgruppen', 'Interesse an Social Media'],
        questions: [
          'Hast du bereits Erfahrung im Marketing?',
          'Kennst du dich mit TikTok, Discord oder Social Media aus?',
          'Wie würdest du unseren Bot bekannter machen?',
          'Hast du Erfahrung mit Content Creation?',
          'Kannst du Grafiken oder Videos erstellen?',
          'Welche Plattformen würdest du für Werbung nutzen?',
          'Was macht gutes Marketing für dich aus?',
          'Hast du Erfahrung mit Community-Wachstum?',
          'Wie würdest du eine neue Bot-Funktion promoten?',
          'Zeige uns Beispiele deiner Arbeit.'
        ]
      }
    ],
    detailAction: {
      label: 'Auf diese Stelle bewerben',
      href: discordInviteUrl
    },
    detailIntroLabel: 'Ausschreibung',
    detailDescriptionLabel: 'Beschreibung',
    detailRequirementsLabel: 'Dein Profil',
    detailNotice: 'Bitte beachte, dass es sich hierbei nicht um eine bezahlte Festanstellung handelt. Wir bieten dir die Möglichkeit, freiwillig an GuildGuardian mitzuwirken und echte Projekterfahrung zu sammeln.',
    detailClosingTitle: 'Jetzt du!',
    detailClosingCopy: 'Du hast bis hier gelesen? Dann bewirb dich und zeig uns, worauf du Lust hast.',
    portal: {
      title: 'Bewerbungsportal',
      lockedTitle: 'Mit Discord anmelden',
      lockedCopy: 'Bevor du deine Bewerbung schreiben kannst, meldest du dich über Discord OAuth an. So können wir deine Bewerbung später eindeutig deinem Discord Account zuordnen.',
      connectAction: 'Mit Discord anmelden',
      connectedLabel: 'Discord Status',
      disconnectAction: 'Verbindung trennen',
      formTitle: 'Deine Bewerbung',
      submitAction: 'Bewerbung absenden',
      submitLoadingAction: 'Wird gesendet...',
      successTitle: 'Bewerbung gesendet',
      successCopy: 'Deine Bewerbung wurde erfolgreich an unser Team übermittelt.',
      questionCountSingular: 'Frage',
      questionCountPlural: 'Fragen',
      optionalLabel: 'Optional',
      authLoadingTitle: 'Discord Anmeldung wird geprüft',
      authLoadingCopy: 'Wir senden deinen Discord Code gerade an die GuildGuardian API und bereiten deine Bewerbung vor.',
      authError: 'Discord Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
      submitErrorTitle: 'Bewerbung konnte nicht gesendet werden',
      sessionInvalidError: 'Deine Discord Sitzung ist ungültig. Bitte melde dich erneut mit Discord an.',
      submitFallbackError: 'Bitte prüfe deine Verbindung oder melde dich erneut mit Discord an.',
      answerPlaceholder: 'Deine Antwort',
      shortAnswerPlaceholder: 'Kurze Antwort',
      urlPlaceholder: 'Link einfügen oder kurz beschreiben',
      detailPlaceholder: 'Falls ja: bitte kurz ergänzen',
      detailExperiencePlaceholder: 'Falls ja: kurz beschreiben',
      detailDatabasePlaceholder: 'Falls ja: z.B. MySQL, PostgreSQL, MongoDB...',
      detailFrameworkPlaceholder: 'Falls ja: Welche Frameworks?',
      detailMoreInfoPlaceholder: 'Weitere Angaben oder kurze Einschätzung',
      yesOption: 'Ja',
      noOption: 'Nein',
      generalQuestionsTitle: 'Allgemeine Fragen',
      generalQuestionsCopy: 'Diese Fragen gelten für alle Bewerbungen.',
      generalQuestions: [
        'Wie heißt du?',
        'Wie alt bist du?',
        'In welcher Zeitzone bzw. welchem Land lebst du?',
        'Seit wann nutzt du Discord aktiv?',
        'Hast du bereits Erfahrung in Teams oder Projekten gesammelt?',
        'Warum möchtest du Teil unseres Teams werden?',
        'Wie viel Zeit kannst du pro Woche investieren?',
        'Was sind deine größten Stärken?',
        'Was sind deine Schwächen?',
        'Wie gehst du mit Kritik oder Stresssituationen um?',
        'Warum sollten wir genau dich nehmen?',
        'Hast du bereits Erfahrung mit großen Discord-Servern oder Bots?',
        'Gibt es Projekte oder Arbeiten von dir, die du zeigen möchtest?',
        'Arbeitest du lieber alleine oder im Team?',
        'Gibt es noch etwas, das wir über dich wissen sollten?'
      ],
      optionalQuestionsTitle: 'Zusatzfragen',
      optionalQuestionsCopy: 'Diese Fragen sind optional.',
      optionalQuestions: [
        'Wie hast du von uns erfahren?',
        'Welche Rolle interessiert dich am meisten?',
        'Welche Rolle interessiert dich zusätzlich?',
        'Wärst du bereit, an Meetings teilzunehmen?',
        'Besitzt du ein funktionierendes Mikrofon?',
        'Wie aktiv bist du durchschnittlich täglich?',
        'Hast du Erfahrung mit internationalen Teams?',
        'Was erwartest du von unserem Team?'
      ],
      fields: {
        discordName: 'Discord Name',
        age: 'Alter',
        experience: 'Welche Erfahrung bringst du für diese Position mit?',
        motivation: 'Warum möchtest du bei GuildGuardian mitwirken?',
        availability: 'Wie viel Zeit kannst du pro Woche einbringen?',
        portfolio: 'Links zu Projekten, GitHub, Website oder Referenzen',
        finalNote: 'Was sollten wir noch über dich wissen?'
      },
      placeholders: {
        discordName: '@deinname',
        age: 'z.B. 16',
        experience: 'Beschreibe kurz deine Erfahrung, Tools und Stärken.',
        motivation: 'Was motiviert dich an GuildGuardian und dieser Rolle?',
        availability: 'z.B. 5-8 Stunden pro Woche',
        portfolio: 'https://...',
        finalNote: 'Optional'
      }
    },
    backAction: 'Zurück zur Karriere',
    betaTeaser: {
      title: 'Du willst lieber neue Funktionen testen?',
      copy: 'Neben den Team-Positionen kannst du dich auch für unser BETA Tester Programm bewerben und neue GuildGuardian Features vor Release ausprobieren.',
      action: 'Beta Programm ansehen',
      href: '/Beta',
      icon: 'bug'
    },
    stepsTitle: 'So läuft deine Bewerbung',
    steps: [
      { number: '01', title: 'Position auswählen', copy: 'Öffne die passende Bewerbungsseite für die Rolle, die wirklich zu dir passt.' },
      { number: '02', title: 'Discord verbinden', copy: 'Verknüpfe deinen Discord Account direkt auf der Bewerbungsseite, damit wir deine Bewerbung eindeutig zuordnen können.' },
      { number: '03', title: 'Formular ausfüllen', copy: 'Beantworte die allgemeinen Fragen und die rollenspezifischen Fragen so konkret wie möglich.' },
      { number: '04', title: 'Prüfung & Rückmeldung', copy: 'Nach dem Absenden prüfen wir deine Bewerbung intern und melden uns anschließend über Discord bei dir.' }
    ]
  },
  serverShowcase: {
    kicker: 'Unsere größten Server',
    title: 'Große Discord Server, die GuildGuardian vertrauen.',
    copy: 'Von Communitys bis Roleplay-Servern: GuildGuardian schützt aktive Discord Server mit klaren Tools und stabiler Automation.',
    memberLabel: 'Mitglieder',
    stats: [
      { value: '375', label: 'Discord Server', icon: 'server' },
      { value: '39.746', label: 'Nutzer', icon: 'team' }
    ]
  },
  servers: [
    { initials: 'HF', name: 'Hübifamily', members: '7821', tone: 'rainbow' },
    { initials: 'TV', name: 'Team Vavory | DE', members: '7345', tone: 'mono' },
    { initials: 'BS', name: 'BoostTech Solutions V3.0', members: '3001', tone: 'cyan' },
    { initials: 'BR', name: 'Berlin RP | V1', members: '2635', tone: 'blue' },
    { initials: 'TC', name: 'Crobix Community', members: '2044', tone: 'violet' }
  ],
  featurePreview: {
    kicker: 'Features',
    title: 'Alles für sichere und aktive Discord Server.',
    action: 'Mehr Features',
    actionHref: '/Features',
    items: [
      { icon: 'shield', title: 'Moderation', copy: 'Professionelle Moderations-Tools' },
      { icon: 'message', title: 'Welcome & Leave', copy: 'Willkommensnachrichten und Auto-Rollen' },
      { icon: 'bell', title: 'Notifications', copy: 'Twitch und YouTube Benachrichtigungen' },
      { icon: 'logs', title: 'Logging', copy: 'Umfassende Audit-Logs' }
    ],
    setup: {
      kicker: 'Setup',
      title: 'Leg innerhalb von Sekunden los.',
      copy: 'GuildGuardian ist so aufgebaut, dass dein Team ohne komplizierte Einrichtung direkt starten kann.',
      steps: [
        {
          image: 'invite',
          title: 'Einladen',
          copy: 'Lade GuildGuardian auf deinen Discord Server ein und wähle den passenden Server.'
        },
        {
          image: 'login',
          title: 'Einloggen',
          copy: 'Melde dich mit Discord an und öffne dein Dashboard.'
        },
        {
          image: 'configure',
          title: 'Konfigurieren',
          copy: 'Aktiviere Moderation, Rollen, Logs und Automationen passend zu deinem Server.'
        }
      ]
    }
  },
  featuresPage: {
    kicker: 'GuildGuardian Features',
    title: 'Mehr Kontrolle, weniger Chaos.',
    copy: 'GuildGuardian verbindet Moderation, Sicherheit, Automationen und Logs in einem System, das dein Team schnell versteht.',
    features: [
      { icon: 'shield', title: 'Moderation', copy: 'Verwalte Warns, Timeouts, Bans und Moderationsabläufe klar und nachvollziehbar.' },
      { icon: 'message', title: 'Welcome & Leave', copy: 'Begrüße neue Mitglieder automatisch und steuere Rollen direkt beim Beitritt.' },
      { icon: 'bell', title: 'Notifications', copy: 'Informiere deine Community über Twitch, YouTube und wichtige Updates.' },
      { icon: 'logs', title: 'Logging', copy: 'Halte Rollen, Channels, Nachrichten und Moderationsaktionen sauber im Blick.' },
      { icon: 'ticket', title: 'Tickets', copy: 'Erstelle Supportabläufe für Fragen, Reports und Teamkontakte.' },
      { icon: 'lock', title: 'Security', copy: 'Schütze deinen Server vor Spam, Werbung und riskanten Aktionen.' }
    ]
  },
  benefits: [
    {
      number: '01',
      title: 'Alles zentral steuerbar',
      copy: 'Konfiguriere Moderation, Tickets, Willkommensnachrichten, Rollen und Logs an einem Ort.'
    },
    {
      number: '02',
      title: 'Sicherheit ohne Dauerstress',
      copy: 'Anti Nuke, AutoMod und Spam-Erkennung greifen ein, bevor dein Team den ganzen Chat durchsuchen muss.'
    },
    {
      number: '03',
      title: 'Bereit für Wachstum',
      copy: 'Invite Tracking, saubere Logs und Premium-Optionen geben auch größeren Servern die nötige Kontrolle.'
    }
  ],
  securityFeatures: [
    {
      icon: 'AN',
      title: 'Anti Nuke',
      copy: 'Erkennt riskante Aktionen, schützt Rollen und Channels und stoppt Eskalationen schneller.'
    },
    {
      icon: 'IT',
      title: 'Invite Tracking',
      copy: 'Behalte Wachstum, Einladungen und auffällige Muster direkt im Blick.'
    },
    {
      icon: 'CM',
      title: 'Automatische Moderation',
      copy: 'Spam, Werbung und wiederholte Verstöße werden erkannt, entfernt und sauber geloggt.'
    }
  ],
  steps: [
    {
      number: '1',
      title: 'Bot einladen',
      copy: 'Füge GuildGuardian deinem Server hinzu und gib dem Bot die benötigten Rechte.'
    },
    {
      number: '2',
      title: 'Dashboard öffnen',
      copy: 'Melde dich mit Discord an und wähle den Server, den du verwalten willst.'
    },
    {
      number: '3',
      title: 'Module aktivieren',
      copy: 'Schalte Sicherheit, Tickets, Logs und Automationen passend zu deinem Server frei.'
    }
  ],
  reviews: [
    {
      name: 'Knaller',
      avatar: 'knaller',
      copy: 'Hallo, meisterkeks ist der beste Programmierer, den es gibt! Braucht ihr einen Bot für Discord welcher Tickets, Embeds, Welcome Message und noch vieles mehr kann, meldet euch auf dem Support Discord!'
    },
    {
      name: 'DamagingAngvels',
      avatar: 'damagingAngvels',
      copy: 'Ich habe mit GuildGuardian sehr gute Erfahrung bis jetzt gemacht. Gewisse Sachen haben am Anfang zwar noch nicht perfekt funktioniert, dies wurde aber sofort gefixt als ich es gemeldet habe. Dies ist der einzige Bot der gerade meiner Meinung nach sehr gut. Das Team dahin ist zuverlässig und professionell.'
    },
    {
      name: 'Marcel',
      avatar: 'marcel',
      copy: 'GuildGuardian ist einer der besten Bots, welche ich bis jetzt benutzt habe. Allgemein kann man nur sagen, dass dies eines der besten Systeme ist.'
    }
  ],
  faq: [
    {
      question: 'Warum sollte ich GuildGuardian nutzen?',
      answer: 'GuildGuardian bietet viele nützliche Funktionen wie AutoMessages, AutoRoles oder SelfRoles, welche für jeden Discord sinnvoll sind. Außerdem ist GuildGuardian für seine AntiNuke-Funktionen sehr beliebt.'
    },
    {
      question: 'Wie funktioniert GuildGuardian?',
      answer: 'Sobald du GuildGuardian auf deinen Server einlädst, wird dein Discord automatisch registriert und dem Inhaber werden privat Informationen geschickt, wie er auf das Dashboard zugreifen kann.'
    },
    {
      question: 'GuildGuardian kann einen Nutzer nicht verwalten?',
      answer: 'GuildGuardian ist vom Discord-Rechte-System nicht ausgeschlossen. Der Inhaber des Discords sollte am besten die Rolle von GuildGuardian nach ganz oben verschieben, damit GuildGuardian sein volles Potenzial nutzen kann.'
    },
    {
      question: 'Ich habe eine Idee für ein Feature?',
      answer: 'Das hört sich super an. Du kannst alle Ideen, die du hast, auf unserem Support Discord im #suggestions Channel posten.'
    }
  ],
  faqLabels: {
    kicker: 'Support',
    title: 'Häufig gestellte Fragen'
  },
  legalPages: {
    imprint: {
      eyebrow: 'Imprint | Privacy',
      title: 'Impressum',
      subtitle: 'Angaben gemäß § 5 DDG',
      updatedLabel: 'Rechtliche Informationen',
      backLabel: 'Zurück zur Website',
      blocks: imprintBlocks
    },
    privacy: {
      eyebrow: 'Privacy',
      title: 'Datenschutzerklärung',
      subtitle: 'Informationen zur Verarbeitung personenbezogener Daten',
      updatedLabel: 'Datenschutz',
      backLabel: 'Zurück zur Website',
      blocks: privacyBlocks
    }
  },
  footerLinks: {
    copy: 'Der Discord Bot für Sicherheit, Moderation und Wachstum deines Servers.',
    copyright: '© GuildGuardian, All Right Reserved.',
    homeLabel: 'GuildGuardian Startseite',
    navigationLabel: 'Footer Navigation',
    backToTop: 'Zurück nach oben',
    socialTitle: 'Socials',
    socials: [
      { label: 'Discord', href: discordInviteUrl, icon: 'discord' },
      { label: 'YouTube', href: youtubeUrl, icon: 'youtube' },
      { label: 'TikTok', href: tiktokUrl, icon: 'tiktok' },
      { label: 'X', href: xUrl, icon: 'x' },
      { label: 'Instagram', href: instagramUrl, icon: 'instagram' }
    ],
    columns: [
      {
        title: 'GuildGuardian',
        links: [
          { label: 'Dashboard', href: dashboardUrl },
          { label: 'Bot einladen', href: botInviteUrl },
          { label: 'Premium', href: '/Premium' },
          { label: 'Status', href: 'https://stats.uptimerobot.com/e9IjVAPipk' }
        ]
      },
      {
        title: 'Ressourcen',
        links: [
          { label: 'Dokumentation', href: '/Dokumentation' },
          { label: 'Support Discord', href: discordInviteUrl },
          { label: 'Beta Tester Programm', href: '/Beta' },
          { label: 'Projekt unterstützen', href: '/Unterstuetzen' }
        ]
      },
      {
        title: 'Unternehmen',
        links: [
          { label: 'Karriere', href: '/Karriere', badge: 'Wir stellen ein' },
          { label: 'Team', href: '/Team' },
          { label: 'Kontakt', href: 'mailto:kontakt@guildguardian.de' },
          { label: 'Datenschutz', href: '/privacy' },
          { label: 'Impressum', href: '/imprint' }
        ]
      }
    ]
  }
}

const englishHomepageContent = {
  navigation: [
    { label: 'Home', href: '/', icon: 'home' },
    { label: 'Features', href: '/#features', icon: 'star' },
    { label: 'Team', href: '/Team', icon: 'team' },
    { label: 'Status', href: 'https://stats.uptimerobot.com/e9IjVAPipk', icon: 'status' },
    { label: 'Support', href: '/#faq', icon: 'info' },
    { label: 'Dashboard', href: dashboardUrl, icon: 'dashboard' },
    { label: 'Resources', href: '#resources', icon: 'resources' }
  ],
  language: {
    label: 'English',
    shortLabel: 'EN'
  },
  resources: {
    columns: [
      {
        title: 'Support',
        items: [
          {
            title: 'Tutorials',
            copy: 'Read our documentation to learn how to use GuildGuardian on Discord.',
            icon: 'info',
            href: '/Dokumentation'
          },
          {
            title: 'Support the Project',
            copy: 'Help through feedback, beta tests, recommendations or later Premium so GuildGuardian can keep improving.',
            icon: 'heart',
            href: '/Support-Project'
          },
          {
            title: 'Discord Server',
            copy: 'Join our Discord server to get help and talk with the community.',
            icon: 'discord',
            href: discordInviteUrl
          }
        ]
      },
      {
        title: 'Company',
        items: [
          {
            title: 'Careers',
            badge: 'We are hiring!',
            copy: 'Join GuildGuardian and build systems that make online communities better.',
            icon: 'team',
            href: '/Karriere'
          },
          {
            title: 'BETA Tester Program',
            copy: 'Test the newest GuildGuardian features, find issues and send feedback to us.',
            icon: 'bug',
            href: '/Beta'
          },
          {
            title: 'Contact us',
            copy: 'We are open and friendly. Reach out if you have questions or ideas.',
            icon: 'contact',
            href: 'mailto:kontakt@guildguardian.de'
          }
        ]
      }
    ]
  },
  headerActions: [
    { label: 'Premium', href: '/premium', variant: 'premium', icon: 'crown' },
    { label: 'Dashboard', href: dashboardUrl, variant: 'dashboard', icon: 'dashboard' }
  ],
  hero: {
    kicker: 'GuildGuardian for Discord',
    titleLines: ['Security for your server.', 'Moderation without chaos.'],
    copy: 'Automate protection, tickets, logs and invite tracking in one dashboard your team can use fast.',
    primaryAction: {
      label: 'Invite bot',
      href: botInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'View features',
      href: '#features',
      icon: 'star'
    }
  },
  premium: {
    kicker: 'Premium',
    title: 'More control for your Discord server.',
    copy: 'Choose your monthly GuildGuardian subscription and unlock more applications, embeds, custom bot options and comfort features.',
    billingLabel: 'Monthly subscriptions only',
    recommendedLabel: 'Popular',
    tableTitle: 'Compare every plan',
    tableCopy: 'All limits and features at a glance. You can start free and upgrade later.',
    includedLabel: 'Included',
    notIncludedLabel: 'Not included',
    primaryAction: {
      label: 'Choose plan in dashboard',
      href: premiumPurchaseUrl,
      icon: 'dashboard'
    },
    secondaryAction: {
      label: 'Compare plans',
      href: '#premium-plans',
      icon: 'star'
    },
    plans: [
      {
        name: 'Free',
        price: '0 €',
        period: '/ month',
        description: 'For smaller servers that want to try GuildGuardian and use the essential core features.',
        action: 'Start free',
        href: premiumPurchaseUrl,
        icon: 'shield',
        highlights: ['3 applications', '3 embeds', '2 apply limits']
      },
      {
        name: 'Freemium',
        badge: 'Popular',
        notice: 'Includes ads',
        price: '0 €',
        period: '/ month',
        description: 'A free upgrade with more limits and comfort features. In return, significantly more ads are shown.',
        action: 'Choose Freemium',
        href: premiumPurchaseUrl,
        icon: 'spark',
        featured: true,
        highlights: ['Custom bot included', '5 applications', '10 embeds', 'Stats and import']
      },
      {
        name: 'Premium',
        price: '9.99 €',
        period: '/ month',
        description: 'For larger servers and teams that need unlimited limits and maximum control.',
        action: 'Choose Premium',
        href: premiumPurchaseUrl,
        icon: 'crown',
        highlights: ['Unlimited applications', 'Unlimited embeds', 'Custom bot']
      }
    ],
    comparisonColumns: ['Free', 'Freemium', 'Premium'],
    comparisonGroups: [
      {
        title: 'General',
        rows: [
          { label: 'Ads shown', values: ['No', 'Yes', 'No'] },
          { label: 'Custom bot', values: [false, true, true] },
          { label: 'Edit global embeds', values: [false, true, true] },
          { label: 'Applications', values: ['3', '5', 'Unlimited'] },
          { label: 'Stats', values: [false, true, true] }
        ]
      },
      {
        title: 'Embeds',
        rows: [
          { label: 'Amount', values: ['3', '10', 'Unlimited'] },
          { label: 'Import', values: [false, true, true] }
        ]
      },
      {
        title: 'Apply',
        rows: [
          { label: 'Limit', values: ['2', '5', 'Unlimited'] },
          { label: 'Lists', values: [false, true, true] }
        ]
      },
      {
        title: 'Join',
        rows: [
          { label: 'Images', values: [false, true, true] },
          { label: 'Dynamic images', values: [false, true, true] },
          { label: 'Private message', values: [false, true, true] }
        ]
      }
    ],
    note: 'Prices and features may still change before the final release.'
  },
  maintenancePages: {
    features: {
      kicker: 'Maintenance',
      title: 'The features page is being reworked.',
      copy: 'We are reorganizing the content so you can browse all GuildGuardian features more clearly later.',
      primaryAction: {
        label: 'Back home',
        href: '/',
        icon: 'home'
      },
      secondaryAction: {
        label: 'Join Discord',
        href: discordInviteUrl,
        icon: 'discord'
      }
    },
    documentation: {
      kicker: 'Documentation',
      title: 'The documentation is currently being built.',
      copy: 'Tutorials, setup guides and explanations are being prepared. Until then, you can get help directly on our Discord server.',
      primaryAction: {
        label: 'Join Discord',
        href: discordInviteUrl,
        icon: 'discord'
      },
      secondaryAction: {
        label: 'Back home',
        href: '/',
        icon: 'home'
      }
    }
  },
  supportProjectPage: {
    kicker: 'Support the project',
    title: 'Help make GuildGuardian better.',
    copy: 'GuildGuardian grows through active servers, honest feedback and people who test new features. You can support the project meaningfully without spending money.',
    status: 'Community Support',
    primaryAction: {
      label: 'Join Discord',
      href: discordInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'Invite bot',
      href: botInviteUrl,
      icon: 'dashboard'
    },
    noteKicker: 'Important',
    noteTitle: 'Right now support is mostly free.',
    noteCopy: 'A direct donation feature is not active yet. If Premium or other support options become available, they will be announced officially. Until then, activity, feedback and recommendations help the most.',
    options: [
      {
        icon: 'dashboard',
        title: 'Use GuildGuardian actively',
        copy: 'Invite the bot to your server and use protection, ticket and logging features in real workflows.',
        action: 'Open dashboard',
        href: dashboardUrl
      },
      {
        icon: 'message',
        title: 'Give feedback',
        copy: 'Tell us which features are missing, which flows are unclear and where the dashboard should be simpler.',
        action: 'Open Discord',
        href: discordInviteUrl
      },
      {
        icon: 'bug',
        title: 'Become a beta tester',
        copy: 'Test new features earlier, report issues clearly and help make releases more stable.',
        action: 'View beta program',
        href: '/Beta'
      },
      {
        icon: 'team',
        title: 'Join the team',
        copy: 'If you want to help long term, you can apply for open roles in the team.',
        action: 'View careers',
        href: '/Karriere'
      },
      {
        icon: 'spark',
        title: 'Recommend the project',
        copy: 'Recommend GuildGuardian to other Discord servers that need moderation, tickets or protection tools.',
        action: 'View features',
        href: '/Features'
      },
      {
        icon: 'crown',
        title: 'Keep an eye on Premium',
        copy: 'Premium will launch later with GuildGuardian V3. It will let you support the project more directly in the future.',
        action: 'View Premium',
        href: '/Premium'
      }
    ],
    impactKicker: 'Why it helps',
    impactTitle: 'Your support goes directly into the product.',
    impact: [
      'Feedback shows us which features are actually needed.',
      'Active servers help uncover issues under real conditions.',
      'Beta tests make new releases more stable and easier to understand.',
      'Recommendations bring more communities to GuildGuardian.',
      'Applications help us improve support, development and community work.'
    ]
  },
  betaPage: {
    kicker: 'Beta Tester Program',
    title: 'Test new GuildGuardian features before they go live.',
    copy: 'The beta program gives you early access to new systems, dashboard changes and bot features. You help us find bugs, improve flows and make GuildGuardian more stable.',
    signal: 'Early Access',
    primaryAction: {
      label: 'Apply on Discord',
      href: discordInviteUrl,
      icon: 'discord'
    },
    secondaryAction: {
      label: 'View features',
      href: '/Features',
      icon: 'star'
    },
    voluntaryKicker: 'Important note',
    voluntaryTitle: 'Voluntary and unpaid.',
    voluntaryCopy: 'The beta tester program is voluntary. Finding, reporting or documenting bugs does not include money, payouts or guaranteed rewards. You help because you want to improve GuildGuardian and test early features.',
    highlights: [
      {
        icon: 'spark',
        title: 'Early access',
        copy: 'You test new features before they are enabled for all servers.'
      },
      {
        icon: 'bug',
        title: 'Report bugs',
        copy: 'You document bugs, unclear flows and places where something does not feel logical.'
      },
      {
        icon: 'message',
        title: 'Give feedback',
        copy: 'You tell us which features are useful and what real Discord teams still need.'
      },
      {
        icon: 'lock',
        title: 'Test confidentially',
        copy: 'Beta content stays internal until it is officially announced or released.'
      },
      {
        icon: 'team',
        title: 'Direct exchange',
        copy: 'You talk directly with the team and developers so feedback can be handled quickly.'
      },
      {
        icon: 'status',
        title: 'Check stability',
        copy: 'You help verify whether new systems work reliably in real server workflows.'
      }
    ],
    processKicker: 'Process',
    processTitle: 'How the beta program works.',
    steps: [
      {
        number: '01',
        title: 'Join Discord',
        copy: 'You join our Discord and tell us that you are interested in the beta tester program.'
      },
      {
        number: '02',
        title: 'Introduce yourself',
        copy: 'We check whether you are active, can give clear feedback and test reliably.'
      },
      {
        number: '03',
        title: 'Get beta access',
        copy: 'If it fits, you get access to beta channels, test notes and new features.'
      },
      {
        number: '04',
        title: 'Test and report',
        copy: 'You test new features and report issues with clear information and screenshots.'
      }
    ],
    expectationsTitle: 'What we expect',
    expectations: [
      'You are regularly reachable on Discord.',
      'You give clear, honest and constructive feedback.',
      'You report bugs with reproducible steps.',
      'You keep beta content confidential.',
      'You want to genuinely improve GuildGuardian.'
    ],
    notForTitle: 'Not a fit if',
    notFor: [
      'you only want early features but do not give feedback.',
      'you share internal content publicly.',
      'you are rarely reachable.',
      'you report bugs vaguely without details.'
    ]
  },
  teamPage: {
    kicker: 'Team',
    title: 'The people behind GuildGuardian.',
    copy: 'Our team builds protection, dashboard, support and community features directly from real Discord server needs.',
    discordLabel: 'Discord',
    roleLabel: 'Role',
    recruiting: {
      kicker: 'Career',
      title: 'Want to contribute to this project?',
      copy: 'Join the team in support or development and start your GuildGuardian career today.',
      action: 'Apply now',
      href: '/Karriere'
    },
    members: [
      {
        name: 'Meister Keks',
        discord: '@meisterkeks',
        accent: 'gold',
        image: 'meisterKeks',
        positions: ['Owner', 'Head Developer', 'Backend Developer', 'Bot Developer']
      },
      {
        name: 'Thorin',
        discord: '@thorin030',
        accent: 'cyan',
        image: 'damaging',
        positions: ['Owner', 'Frontend Developer', 'Web Developer', 'Community Manager', 'Marketing', 'Team Manager']
      },
      {
        name: 'Damaging',
        discord: '@damaglng',
        accent: 'violet',
        image: 'thorin',
        positions: ['Supporter']
      }
    ]
  },
  careerPage: {
    kicker: 'Careers at GuildGuardian',
    title: 'Build the next version for Discord communities with us.',
    copy: 'We are looking for people who take responsibility, communicate clearly and want to actively improve GuildGuardian.',
    primaryAction: {
      label: 'View open positions',
      href: '#open-positions',
      icon: 'team'
    },
    secondaryAction: {
      label: 'View team',
      href: '/Team',
      icon: 'team'
    },
    ndaNotice: {
      title: 'Important note',
      copy: 'To contribute to GuildGuardian, an NDA (non-disclosure agreement) must be signed so internal data, systems and confidential information stay protected.'
    },
    openingsTitle: 'Open positions',
    openings: [
      {
        icon: 'code',
        title: 'Bot Developer',
        slug: 'botdeveloper',
        copy: 'Build new bot features, commands and automations directly for Discord servers.',
        tags: ['Discord API', 'Commands', 'Automation'],
        detailTitle: 'Develop the core of GuildGuardian.',
        detailCopy: 'As a Bot Developer you work on commands, moderation systems, events and Discord integrations. You think in stable flows and help the bot respond fast and reliably.',
        requirements: ['JavaScript knowledge', 'Interest in Discord bots and APIs', 'Clear team communication'],
        questions: [
          'Which programming languages do you know?',
          'Which Discord libraries do you work with?',
          'Have you already developed your own Discord bots?',
          'How would you rate your knowledge from 1-10?',
          'Do you know databases? If yes, which ones?',
          'Do you have experience with APIs or webhooks?',
          'How do you debug errors?',
          'Do you have experience with Git/GitHub?',
          'Have you worked with slash commands before?',
          'How important are structure and clean code to you?',
          'Can you work under time pressure?',
          'Show us a project or repository of yours.'
        ]
      },
      {
        icon: 'headset',
        title: 'Supporter',
        slug: 'supporter',
        copy: 'Help users with questions, tickets and everyday problems.',
        tags: ['Discord Support', 'Tickets', 'Community'],
        detailTitle: 'Be the first help for our community.',
        detailCopy: 'As a Supporter you answer questions, help with setup and issues, and forward important feedback to the team.',
        requirements: ['Friendly user communication', 'Patience with support cases', 'Basic Discord server knowledge'],
        questions: [
          'Do you already have support experience?',
          'How would you handle a toxic user?',
          'How do you react to stress or many tickets at once?',
          'Can you stay calm and professional?',
          'How active are you usually on Discord?',
          'Why do you want to become a Supporter?',
          'What does good support mean to you?',
          'How would you help a new user?',
          'Do you have experience with ticket systems?',
          'How would you resolve a conflict between two users?'
        ]
      },
      {
        icon: 'code',
        title: 'Api Developer',
        slug: 'apideveloper',
        copy: 'Build JavaScript APIs, data logic and technical foundations for dashboard and systems.',
        tags: ['JavaScript', 'API', 'Server'],
        detailTitle: 'Build the API foundation behind dashboard and bot.',
        detailCopy: 'As an Api Developer you create JavaScript endpoints, data structures and services that power GuildGuardian in the background.',
        requirements: ['JavaScript knowledge', 'Understanding of APIs and data', 'Structured work style'],
        questions: [
          'How well do you know JavaScript?',
          'Which frameworks do you have experience with?',
          'Do you have experience with databases?',
          'Have you already built APIs?',
          'How important is security to you?',
          'Do you know hosting/Linux/Docker?',
          'Do you have experience with authentication systems?',
          'How do you structure larger projects?',
          'Have you worked with real-time systems before?',
          'Show us projects or GitHub repositories.'
        ]
      },
      {
        icon: 'team',
        title: 'Community Manager',
        slug: 'communitymanager',
        copy: 'Keep the community active, inform users and collect feedback.',
        tags: ['Community', 'Feedback', 'Events'],
        detailTitle: 'Connect team and community.',
        detailCopy: 'As a Community Manager you keep activity high, communicate clearly and create a positive atmosphere around GuildGuardian.',
        requirements: ['Strong communication', 'Ideas for community activities', 'Reliability'],
        questions: [
          'Do you have experience in community management?',
          'How would you keep a community active?',
          'What ideas do you have for events or activities?',
          'How do you handle conflicts?',
          'How important is communication to you?',
          'Do you have experience with partnerships?',
          'How would you welcome new members?',
          'What makes a good community?',
          'How would you react to negative feedback?',
          'How active are you on Discord?'
        ]
      },
      {
        icon: 'team',
        title: 'Team Manager',
        slug: 'teammanager',
        copy: 'Coordinate tasks, team processes and internal communication.',
        tags: ['Organization', 'Planning', 'Team'],
        detailTitle: 'Keep the team organized.',
        detailCopy: 'As a Team Manager you help distribute tasks cleanly, keep progress visible and coordinate the team.',
        requirements: ['Organization skills', 'Clear communication', 'Sense of responsibility'],
        questions: [
          'Have you already led teams?',
          'How would you organize tasks in a team?',
          'How do you handle inactive team members?',
          'Can you resolve conflicts neutrally?',
          'How important are structure and planning to you?',
          'How would you encourage motivation in the team?',
          'Do you have experience with project management?',
          'How would you organize deadlines?',
          'How do you handle stressful situations?',
          'What makes a good team lead?'
        ]
      },
      {
        icon: 'megaphone',
        title: 'Marketing',
        slug: 'marketing',
        copy: 'Plan content, announcements and growth for GuildGuardian.',
        tags: ['Content', 'Social', 'Branding'],
        detailTitle: 'Bring GuildGuardian outside.',
        detailCopy: 'In Marketing you create ideas for posts, announcements and campaigns so more servers discover GuildGuardian.',
        requirements: ['Creative ideas', 'Feeling for copy and audiences', 'Interest in social media'],
        questions: [
          'Do you already have marketing experience?',
          'Do you know TikTok, Discord or social media?',
          'How would you make our bot more known?',
          'Do you have experience with content creation?',
          'Can you create graphics or videos?',
          'Which platforms would you use for advertising?',
          'What does good marketing mean to you?',
          'Do you have experience with community growth?',
          'How would you promote a new bot feature?',
          'Show us examples of your work.'
        ]
      }
    ],
    detailAction: {
      label: 'Apply for this position',
      href: discordInviteUrl
    },
    detailIntroLabel: 'Opening',
    detailDescriptionLabel: 'Description',
    detailRequirementsLabel: 'Your profile',
    detailNotice: 'Please note that this is not a paid employment position. We offer you the opportunity to voluntarily contribute to GuildGuardian and gain real project experience.',
    detailClosingTitle: 'Your turn!',
    detailClosingCopy: 'You read this far? Apply now and show us what you want to work on.',
    portal: {
      title: 'Application portal',
      lockedTitle: 'Sign in with Discord',
      lockedCopy: 'Before you can write your application, sign in through Discord OAuth. This lets us assign your application to your Discord account later.',
      connectAction: 'Sign in with Discord',
      connectedLabel: 'Discord status',
      disconnectAction: 'Disconnect',
      formTitle: 'Your application',
      submitAction: 'Submit application',
      submitLoadingAction: 'Sending...',
      successTitle: 'Application sent',
      successCopy: 'Your application has been sent to our team successfully.',
      questionCountSingular: 'question',
      questionCountPlural: 'questions',
      optionalLabel: 'Optional',
      authLoadingTitle: 'Checking Discord sign-in',
      authLoadingCopy: 'We are sending your Discord code to the GuildGuardian API and preparing your application.',
      authError: 'Discord sign-in failed. Please try again.',
      submitErrorTitle: 'Application could not be sent',
      sessionInvalidError: 'Your Discord session is invalid. Please sign in with Discord again.',
      submitFallbackError: 'Please check your connection or sign in with Discord again.',
      answerPlaceholder: 'Your answer',
      shortAnswerPlaceholder: 'Short answer',
      urlPlaceholder: 'Paste a link or briefly describe it',
      detailPlaceholder: 'If yes, briefly add details',
      detailExperiencePlaceholder: 'If yes, briefly describe it',
      detailDatabasePlaceholder: 'If yes: e.g. MySQL, PostgreSQL, MongoDB...',
      detailFrameworkPlaceholder: 'If yes: which frameworks?',
      detailMoreInfoPlaceholder: 'More details or a short rating',
      yesOption: 'Yes',
      noOption: 'No',
      generalQuestionsTitle: 'General questions',
      generalQuestionsCopy: 'These questions apply to all applications.',
      generalQuestions: [
        'What is your name?',
        'How old are you?',
        'Which time zone or country do you live in?',
        'Since when have you actively used Discord?',
        'Have you already gained experience in teams or projects?',
        'Why do you want to become part of our team?',
        'How much time can you invest per week?',
        'What are your biggest strengths?',
        'What are your weaknesses?',
        'How do you handle criticism or stressful situations?',
        'Why should we choose you specifically?',
        'Do you already have experience with large Discord servers or bots?',
        'Are there projects or work samples you would like to show?',
        'Do you prefer working alone or in a team?',
        'Is there anything else we should know about you?'
      ],
      optionalQuestionsTitle: 'Additional questions',
      optionalQuestionsCopy: 'These questions are optional.',
      optionalQuestions: [
        'How did you hear about us?',
        'Which role interests you the most?',
        'Which additional role interests you?',
        'Would you be willing to attend meetings?',
        'Do you have a working microphone?',
        'How active are you on average each day?',
        'Do you have experience with international teams?',
        'What do you expect from our team?'
      ],
      fields: {
        discordName: 'Discord name',
        age: 'Age',
        experience: 'What experience do you bring for this position?',
        motivation: 'Why do you want to contribute to GuildGuardian?',
        availability: 'How much time can you contribute per week?',
        portfolio: 'Links to projects, GitHub, website or references',
        finalNote: 'What else should we know about you?'
      },
      placeholders: {
        discordName: '@yourname',
        age: 'e.g. 16',
        experience: 'Briefly describe your experience, tools and strengths.',
        motivation: 'What motivates you about GuildGuardian and this role?',
        availability: 'e.g. 5-8 hours per week',
        portfolio: 'https://...',
        finalNote: 'Optional'
      }
    },
    backAction: 'Back to careers',
    betaTeaser: {
      title: 'Would you rather test new features?',
      copy: 'Besides team positions, you can also apply for our BETA Tester Program and try new GuildGuardian features before release.',
      action: 'View beta program',
      href: '/Beta',
      icon: 'bug'
    },
    stepsTitle: 'How your application works',
    steps: [
      { number: '01', title: 'Choose a position', copy: 'Open the application page for the role that actually fits you.' },
      { number: '02', title: 'Connect Discord', copy: 'Link your Discord account directly on the application page so we can assign your application clearly.' },
      { number: '03', title: 'Fill out the form', copy: 'Answer the general questions and the role-specific questions as clearly as possible.' },
      { number: '04', title: 'Review & response', copy: 'After submission, we review your application internally and then contact you through Discord.' }
    ]
  },
  serverShowcase: {
    kicker: 'Our biggest servers',
    title: 'Large Discord servers that trust GuildGuardian.',
    copy: 'From communities to roleplay servers: GuildGuardian protects active Discord servers with clear tools and stable automation.',
    memberLabel: 'members',
    stats: [
      { value: '375', label: 'Discord servers', icon: 'server' },
      { value: '39,746', label: 'users', icon: 'team' }
    ]
  },
  servers: [
    { initials: 'HF', name: 'Hübifamily', members: '7821', tone: 'rainbow' },
    { initials: 'TV', name: 'Team Vavory | DE', members: '7345', tone: 'mono' },
    { initials: 'BS', name: 'BoostTech Solutions V3.0', members: '3001', tone: 'cyan' },
    { initials: 'BR', name: 'Berlin RP | V1', members: '2635', tone: 'blue' },
    { initials: 'TC', name: 'Crobix Community', members: '2044', tone: 'violet' }
  ],
  featurePreview: {
    kicker: 'Features',
    title: 'Everything for safe and active Discord servers.',
    action: 'More features',
    actionHref: '/Features',
    items: [
      { icon: 'shield', title: 'Moderation', copy: 'Professional moderation tools' },
      { icon: 'message', title: 'Welcome & Leave', copy: 'Welcome messages and auto roles' },
      { icon: 'bell', title: 'Notifications', copy: 'Twitch and YouTube notifications' },
      { icon: 'logs', title: 'Logging', copy: 'Complete audit logs' }
    ],
    setup: {
      kicker: 'Setup',
      title: 'Start within seconds.',
      copy: 'GuildGuardian is built so your team can start without a complicated setup.',
      steps: [
        {
          image: 'invite',
          title: 'Invite',
          copy: 'Invite GuildGuardian to your Discord server and select the right server.'
        },
        {
          image: 'login',
          title: 'Log in',
          copy: 'Sign in with Discord and open your dashboard.'
        },
        {
          image: 'configure',
          title: 'Configure',
          copy: 'Enable moderation, roles, logs and automations for your server.'
        }
      ]
    }
  },
  featuresPage: {
    kicker: 'GuildGuardian Features',
    title: 'More control, less chaos.',
    copy: 'GuildGuardian combines moderation, security, automations and logs in one system your team can understand quickly.',
    features: [
      { icon: 'shield', title: 'Moderation', copy: 'Manage warns, timeouts, bans and moderation workflows clearly.' },
      { icon: 'message', title: 'Welcome & Leave', copy: 'Welcome new members automatically and assign roles on join.' },
      { icon: 'bell', title: 'Notifications', copy: 'Notify your community about Twitch, YouTube and important updates.' },
      { icon: 'logs', title: 'Logging', copy: 'Track roles, channels, messages and moderation actions cleanly.' },
      { icon: 'ticket', title: 'Tickets', copy: 'Create support workflows for questions, reports and team contacts.' },
      { icon: 'lock', title: 'Security', copy: 'Protect your server from spam, ads and risky actions.' }
    ]
  },
  benefits: [
    {
      number: '01',
      title: 'Control everything centrally',
      copy: 'Configure moderation, tickets, welcome messages, roles and logs in one place.'
    },
    {
      number: '02',
      title: 'Security without constant stress',
      copy: 'Anti-nuke, AutoMod and spam detection react before your team has to search the whole chat.'
    },
    {
      number: '03',
      title: 'Ready for growth',
      copy: 'Invite tracking, clean logs and premium options give larger servers the control they need.'
    }
  ],
  securityFeatures: [
    {
      icon: 'AN',
      title: 'Anti Nuke',
      copy: 'Detects risky actions, protects roles and channels, and stops escalations faster.'
    },
    {
      icon: 'IT',
      title: 'Invite Tracking',
      copy: 'Keep growth, invitations and suspicious patterns clearly in view.'
    },
    {
      icon: 'CM',
      title: 'Automatic moderation',
      copy: 'Spam, ads and repeated violations are detected, removed and logged cleanly.'
    }
  ],
  steps: [
    {
      number: '1',
      title: 'Invite the bot',
      copy: 'Add GuildGuardian to your server and grant the required permissions.'
    },
    {
      number: '2',
      title: 'Open the dashboard',
      copy: 'Sign in with Discord and choose the server you want to manage.'
    },
    {
      number: '3',
      title: 'Enable modules',
      copy: 'Activate security, tickets, logs and automations for your server.'
    }
  ],
  reviews: [
    {
      name: 'Knaller',
      avatar: 'knaller',
      copy: 'Tickets, embeds, welcome messages and much more in one bot. If you need a Discord bot with strong support, GuildGuardian is a great fit.'
    },
    {
      name: 'DamagingAngvels',
      avatar: 'damagingAngvels',
      copy: 'I have had a very good experience with GuildGuardian so far. Some things were not perfect at the beginning, but they were fixed immediately after I reported them. The team is reliable and professional.'
    },
    {
      name: 'Marcel',
      avatar: 'marcel',
      copy: 'GuildGuardian is one of the best bots I have used so far. Overall, it is one of the best systems.'
    }
  ],
  faq: [
    {
      question: 'Why should I use GuildGuardian?',
      answer: 'GuildGuardian offers many useful features like AutoMessages, AutoRoles and SelfRoles that make sense for every Discord server. GuildGuardian is also popular for its AntiNuke features.'
    },
    {
      question: 'How does GuildGuardian work?',
      answer: 'Once you invite GuildGuardian to your server, your Discord is registered automatically and the owner receives private information about how to access the dashboard.'
    },
    {
      question: 'GuildGuardian cannot manage a user?',
      answer: 'GuildGuardian still follows Discords permission system. The server owner should move the GuildGuardian role as high as possible so GuildGuardian can use its full potential.'
    },
    {
      question: 'I have an idea for a feature?',
      answer: 'That sounds great. You can post all your ideas on our support Discord in the #suggestions channel.'
    }
  ],
  faqLabels: {
    kicker: 'Support',
    title: 'Frequently asked questions'
  },
  legalPages: {
    imprint: {
      eyebrow: 'Imprint | Privacy',
      title: 'Imprint',
      subtitle: 'Information according to § 5 DDG',
      updatedLabel: 'Legal information',
      backLabel: 'Back to website',
      blocks: imprintBlocks
    },
    privacy: {
      eyebrow: 'Privacy',
      title: 'Privacy Policy',
      subtitle: 'Information about personal data processing',
      updatedLabel: 'Privacy',
      backLabel: 'Back to website',
      blocks: privacyBlocks
    }
  },
  footerLinks: {
    copy: 'The Discord bot for security, moderation and growth on your server.',
    copyright: '© GuildGuardian, All Right Reserved.',
    homeLabel: 'GuildGuardian homepage',
    navigationLabel: 'Footer navigation',
    backToTop: 'Back to top',
    socialTitle: 'Socials',
    socials: [
      { label: 'Discord', href: discordInviteUrl, icon: 'discord' },
      { label: 'YouTube', href: youtubeUrl, icon: 'youtube' },
      { label: 'TikTok', href: tiktokUrl, icon: 'tiktok' },
      { label: 'X', href: xUrl, icon: 'x' },
      { label: 'Instagram', href: instagramUrl, icon: 'instagram' }
    ],
    columns: [
      {
        title: 'GuildGuardian',
        links: [
          { label: 'Dashboard', href: dashboardUrl },
          { label: 'Invite bot', href: botInviteUrl },
          { label: 'Premium', href: '/Premium' },
          { label: 'Status', href: 'https://stats.uptimerobot.com/e9IjVAPipk' }
        ]
      },
      {
        title: 'Resources',
        links: [
          { label: 'Documentation', href: '/Dokumentation' },
          { label: 'Support Discord', href: discordInviteUrl },
          { label: 'Beta Tester Program', href: '/Beta' },
          { label: 'Support the project', href: '/Support-Project' }
        ]
      },
      {
        title: 'Company',
        links: [
          { label: 'Careers', href: '/Karriere', badge: 'We are hiring' },
          { label: 'Team', href: '/Team' },
          { label: 'Contact', href: 'mailto:kontakt@guildguardian.de' },
          { label: 'Privacy', href: '/privacy' },
          { label: 'Imprint', href: '/imprint' }
        ]
      }
    ]
  }
}

const localizedHomepageContent = {
  de: germanHomepageContent,
  en: englishHomepageContent
}

export function isSupportedLocale(locale) {
  return Boolean(localizedHomepageContent[locale])
}

export function getLocalizedHomepageContent(locale = defaultLocale) {
  const activeLocale = isSupportedLocale(locale) ? locale : defaultLocale
  const activeLanguage = supportedLanguages.find((language) => language.code === activeLocale)

  return {
    ...localizedHomepageContent[activeLocale],
    language: activeLanguage,
    languages: supportedLanguages
  }
}

export const homepageContent = getLocalizedHomepageContent(defaultLocale)
